import { useEffect } from "react";

/** Area clienti: nessun referrer in uscita, così gli URL privati non finiscono a terzi. */
export const useNoReferrer = () => {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "referrer";
    meta.content = "no-referrer";
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
};
